import { render, staticRenderFns } from "./PositionSearch.vue?vue&type=template&id=61f7b478&scoped=true"
import script from "./PositionSearch.vue?vue&type=script&lang=js"
export * from "./PositionSearch.vue?vue&type=script&lang=js"
import style0 from "./PositionSearch.vue?vue&type=style&index=0&id=61f7b478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f7b478",
  null
  
)

export default component.exports